import React from "react";
import "../../styles/About/AnimationSection.scss";
import { Col, Container, Row } from "react-bootstrap";
// import ReactPlayer from "react-player";
import mezroAnimatedVideo from "../../../src/assets/videos/mezroAnimatedVideo.mp4";
import ReactPlayer from "react-player";

const AnimationSection = () => {
  return (
    <Container className="my-5">
      <Row>
        <Col md={5}>
          <ReactPlayer
            url={mezroAnimatedVideo}
            playing={true}
            muted={true}
            loop={true}
            playsinline={true}
            width="539"
            height="590"
          />
          {/* <video
              width="539"
              height="590"
              src={mezroAnimatedVideo}
              autoplay="autoplay"
              loop="loop"
              controls="hide"
            /> */}
        </Col>
        <Col md={7}>
          <div className="d-flex align-items-end h-100  flex-column features-style">
            <div data-aos="fade-up" data-aos-delay="250">
              Optimity
            </div>
            <div data-aos="fade-up" data-aos-delay="500">
              Simplicity
            </div>
            <div data-aos="fade-up" data-aos-delay="750">
              Passionate
            </div>
            <div data-aos="fade-up" data-aos-delay="1000">
              Seemliness
            </div>
            <div data-aos="fade-up" data-aos-delay="1000">
              Time Honored Affair
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AnimationSection;
